import { render } from "./menu-sidebar.html?vue&type=template&id=10f9ab60&ts=true&external"
import script from "./menu-sidebar.ts?vue&type=script&lang=ts&external"
export * from "./menu-sidebar.ts?vue&type=script&lang=ts&external"

import "./menu-sidebar.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__